<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('ajoutEditContrat.echeance.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field :label="$t('ajoutEditContrat.echeance.dateDebutEcheance')" class="obligatoire">
            <b-datepicker show-week-number @input="updateDateDebutEcheance"
                          :value="contrat.dateDebutEcheance"
                          icon="calendar-today"
                          nearby-selectable-month-days
                          editable>
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('ajoutEditContrat.echeance.dateFinEcheance')" class="obligatoire">
            <b-datepicker show-week-number @input="updateDateFinEcheance"
                          :value="contrat.dateFinEcheance"
                          icon="calendar-today"
                          nearby-selectable-month-days
                          editable>
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('ajoutEditContrat.echeance.dureePeriodeEcheance')">
            <b-input :value="getDifferenceBetweenDate" :disabled="true"></b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('ajoutEditContrat.echeance.termePaiementLibelle')">
            <b-select :value="contrat.termePaiement" expanded @input="updateTermePaiement">
              <option v-for="termePaiement in constantes.LISTE_TERME_PAIEMENT"
                      :key="termePaiement.code"
                      :value="termePaiement.code">
                {{ $t(termePaiement.libelle) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-3">
          <div class="columns">
            <div class="column is-narrow pdr-0">
              <b-field :label="$t('ajoutEditContrat.echeance.periodicite')"
                       class="obligatoire">
                <b-input :value="contrat.quantitePeriodicite"
                         @input="updateQuantitePeriodicite">
                </b-input>
              </b-field>
            </div>
            <div class="column is-narrow is-flex align-items-flex-end">
              <b-select expanded :value="contrat.unitePeriodicite"
                        @input="updateUnitePeriodicite">
                <option v-for="(periodicite) in constantes.PERIODICITE_UNITE"
                        :key="periodicite.code"
                        :value="periodicite.code">
                  {{ $t(periodicite.libelle) }}
                </option>
              </b-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LISTE_TERME_PAIEMENT, PERIODICITE_UNITE } from '@/configuration/baux/contrat/contratConf';
import getDifferenceBetweenDateLibelleYearsMonthsDays from '@/services/baux/contrat/getDifferenceBetweenDateLibelleYearsMonthsDays';

export default {
  name: 'BauxContratEditEcheance',
  data() {
    return {
      constantes: {
        LISTE_TERME_PAIEMENT,
        PERIODICITE_UNITE,
      },
    };
  },
  props: {
    contrat: {
      type: Object,
      required: true,
    },
    echeancier: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateTermePaiement(value) {
      this.echeancier.termePaiement = value;
      this.contrat.termePaiement = value;
    },
    updateDateDebutEcheance(date) {
      this.echeancier.dateDebut = date;
      this.contrat.dateDebutEcheance = date;
    },
    updateDateFinEcheance(date) {
      this.echeancier.dateFin = date;
      this.contrat.dateFinEcheance = date;
    },
    updateQuantitePeriodicite(value) {
      this.echeancier.quantitePeriodicite = value;
      this.contrat.quantitePeriodicite = value;
    },
    updateUnitePeriodicite(value) {
      this.echeancier.periodiciteEcheancier = value;
      this.contrat.unitePeriodicite = value;
    },
  },
  computed: {
    getDifferenceBetweenDate() {
      return getDifferenceBetweenDateLibelleYearsMonthsDays(
        this.contrat.dateDebutEcheance,
        this.contrat.dateFinEcheance,
        this.$i18n,
      );
    },
  },
};
</script>
